import { render, staticRenderFns } from "./comp_PriceText.vue?vue&type=template&id=9251c388&scoped=true&"
import script from "./comp_PriceText.vue?vue&type=script&lang=js&"
export * from "./comp_PriceText.vue?vue&type=script&lang=js&"
import style0 from "./comp_PriceText.vue?vue&type=style&index=0&id=9251c388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9251c388",
  null
  
)

export default component.exports